import React, {Component} from 'react';
import TooieModal from "./common/TooieModal.react.js";
let i18n = require('i18next');

export default class PurchaseLicenseModal extends Component {
    render() {
        const fontStyle = {color: "#A6AEBA", fontSize: "12px"};
        const marginWechat = {margin: "9px"};
        const margin = {marginTop: "8px"};
        const marginTop = {marginTop: "3px"};
        const payStyle = {textAlign: "left", marginLeft: "90px", clear: "both"};
        return <TooieModal id="purchaseModal" hideHeader="true">
            <div className="purchase-license" data-id={this.props.charges.id}>
                <div className="purchase-header">
                    <span>{i18n.t("pos.license.purchase.title")}</span>
                    <img src={require("../images/pos/pricing/close.png")} className="close-license"/>
                </div>
                <div className="purchase-body">
                    <div className="order-page">
                        <div className="purchase-row">
                            <label className="pull-left">{i18n.t("pos.license.purchase.mode")}</label>

                            <div>
                                <span>{i18n.t("pos.license.purchase.mouth")}</span>
                            </div>
                        </div>
                        <div className="purchase-row">
                            <label className="pull-left align">{i18n.t("pos.license.purchase.plan")}</label>

                            <div className="device-choose pull-left">
                                <div className="device-quantity basic checked">
                                    <img className="checked-img" src={require("../images/pos/pricing/checked.png")}/>
                                    <span className="pull-left">{i18n.t("pos.license.purchase.base")}</span>
                                </div>

                                <div className="device-quantity custom">
                                    <img className="checked-img" src={require("../images/pos/pricing/checked.png")}/>
                                    <span className="pull-left">{i18n.t("pos.license.purchase.custom")}</span>

                                    <div className="edit-quantity pull-right">
                                        <img className="minus" src={require("../images/pos/pricing/minus.png")}/>
                                        <span>2</span>
                                        <img className="plus" src={require("../images/pos/pricing/plus.png")}/>
                                    </div>
                                </div>
                                <span style={fontStyle}>{i18n.t("pos.license.purchase.tip1")}</span>
                            </div>
                        </div>
                        <div className="purchase-row">
                            <label className="pull-left align">{i18n.t("pos.license.purchase.pay")}</label>

                            <div className="paymode pull-left">
                                <div className="paymode-choose checked" data-channel="alipay_qr">
                                    <img className="checked-img" src={require("../images/pos/pricing/checked.png")}/>
                                    <img className="pull-left" src={require("../images/pos/pricing/alipayicon.png")}/>
                                    <span className="pull-right">{i18n.t("pos.license.purchase.alipay")}</span>
                                </div>

                                <div className="paymode-choose" data-channel="wx_pub_qr">
                                    <img className="checked-img" src={require("../images/pos/pricing/checked.png")}/>
                                    <img className="pull-left" style={marginWechat}
                                         src={require("../images/pos/pricing/wechat.png")}/>
                                    <span className="pull-right">{i18n.t("pos.license.purchase.weixin")}</span>
                                </div>

                                <div className="paymode-choose" data-channel="tooie">
                                    <img className="checked-img"
                                         src={require("../images/pos/pricing/checked.png")}/>
                                    <img className="pull-left" src={require("../images/pos/pricing/tooie.png")}/>
                                    <span className="pull-right">{i18n.t("pos.license.purchase.tooie")}</span>
                                </div>
                            </div>
                        </div>
                        <div className="purchase-row">
                            <label className="pull-left" style={margin}>{i18n.t("pos.license.purchase.time")}</label>

                            <div>
                                <select className="license-duration form-control">
                                    <option value="1">1</option>
                                    <option value="3">3</option>
                                    <option value="6">6</option>
                                    <option value="12">12</option>
                                </select>
                                <span>{i18n.t("pos.license.purchase.unit1")}</span>
                            </div>
                        </div>
                        <div className="purchase-row">
                            <label className="pull-left" style={marginTop}>{i18n.t("pos.license.purchase.shouldPay")}</label>

                            <div className="should-pay">
                                <span className="text-span">{this.props.charges.price}</span>{i18n.t("pos.license.purchase.unit2")}
                            </div>
                        </div>
                        <div className="purchase-row hidden qrcode">
                            <label className="pull-left">{i18n.t("pos.license.purchase.qrcode")}</label>

                            <div>
                                <img className="pay-code"/>
                            </div>
                            <img className="pay-model-alipay hidden"
                                 src={require("../images/pos/pricing/alipayPay.png")}/>
                            <img className="pay-model-wechat hidden"
                                 src={require("../images/pos/pricing/wechatpay.png")}/>
                        </div>
                        <div style={payStyle}>
                            <button className="btn pay-order">{i18n.t("pos.license.purchase.paybtn")}</button>
                        </div>
                    </div>
                    <div className="paid-success hidden">
                        <img src={require("../images/pos/pricing/gougou.png")}/>
                        <span>{i18n.t("pos.license.purchase.successed")}</span>
                    </div>
                </div>
                <div className="purchase-footer">
                    <span><img src={require("../images/pos/pricing/tip.png")}/>{i18n.t("pos.license.purchase.tip2")}<span
                        className="important-tip">{i18n.t("pos.license.purchase.tip3")}</span></span>
                </div>
            </div>
        </TooieModal >
    }
}



// WEBPACK FOOTER //
// ./src/react/PurchaseLicenseModal.react.js